<template>
  <v-card>
    <v-card-title>
      <v-btn color="primary" dark class="mb-2" @click="ConfirmPickupSelected()">
        Confirm all selected as delivered
      </v-btn>
      <v-spacer></v-spacer>
      <h2>In delivery</h2>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark class="mb-2" @click="editMultiple()">
        Edit all selected
      </v-btn>
    </v-card-title>
    <v-data-table
      dense
      v-model="selected"
      :single-select="false"
      :headers="headers"
      :items="transportOrders"
      :search="search"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :loading="isLoading"
      :items-per-page="25"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
      :sort-by="'ConfirmedPickupTime'"
      :sort-desc="true"
      :custom-sort="customSort"
      item-key="Id"
      show-expand
      show-select
      class="elevation-1"
      loading-text="Loading... Please wait"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="green lighten-5">
          <v-container>
            <v-row :colspan="headers.length" no-gutters>
              <v-col cols="4">
                <v-card height="220px">
                  <!-- <v-card-title class="subtitle-2"> Order info </v-card-title> -->
                  <v-card-text>
                    <div class="oneLine"><b>Brand:</b> {{ item.Brand }}</div>
                    <div class="oneLine"><b>Model:</b> {{ item.Model }}</div>
                    <!-- <div class="oneLine"><b>VIN:</b> {{ item.Vin }}</div> -->
                    <div class="oneLine"><b>Regno:</b> {{ item.RegNo }}</div>
                    <div class="oneLine">
                      <b>Orig. regno:</b> {{ item.ForeignLicensePlate }}
                    </div>
                    <div class="oneLine">
                      <b>Pickup outlet:</b> {{ item.PickupOutletName }}
                    </div>
                    <div class="oneLine">
                      <b>Delivery address:</b> {{ item.DestinationAddress }}
                    </div>
                    <div class="oneLine">
                      <b>Created by:</b> {{ item.CreateBy }}
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      elevation="2"
                      x-small
                      @click="ShowHistory(item)"
                      >Show order history</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red"
                      elevation="2"
                      x-small
                      @click="ReturnToPrevious(item)"
                      >Cancel to waiting</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="220px">
                  <v-card-text>
                    <div class="oneLine">
                      <v-textarea
                        name="pickupInformation"
                        label="Kamux pickup information"
                        v-model="item.PickupInformation"
                        disabled
                      ></v-textarea>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="220px">
                  <v-card-text>
                    <div class="oneLine">
                      <v-textarea
                        name="transportNotes"
                        label="Transport notes"
                        v-model="item.TransportNotes"
                        height="120"
                      ></v-textarea>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          elevation="2"
                          x-small
                          @click="SaveTransportNotes(item)"
                          >Save</v-btn
                        >
                      </v-card-actions>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </td>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          color="primary"
          elevation="3"
          x-small
          @click="ConfirmPickup(item)"
          >Confirm</v-btn
        >
      </template>
      <template v-slot:[`item.actionsEdit`]="{ item }">
        <v-btn color="primary" elevation="3" x-small @click="editSingle(item)"
          >Edit</v-btn
        >
      </template>
      <template v-slot:[`item.Ref`]="props">
        <v-edit-dialog
          :return-value.sync="props.item.Ref"
          large
          persistent
          @save="saveRef(props.item)"
        >
          <div>{{ props.item.Ref }}</div>
          <template v-slot:input>
            <div class="mt-4 text-h6">Update REF</div>
            <v-text-field
              v-model="props.item.Ref"
              :rules="[maxChars]"
              label="Edit"
              single-line
              counter
              autofocus
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="1000px">
      <v-card v-if="single">
        <v-card-title>
          <span class="text-h5"
            >Confirm vehicle delivered to store ({{ editedItem.RegNo }})</span
          >
          <span class="text-subtitle-1 mt-5">
            Please confirm that the car has been delivered to the destination as
            agreed.
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" lg="12">
                <span class="text-subtitle-1">
                  This vehicle has been delivered?
                </span>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <v-container class="mt-0">
              <v-row>
                <v-col cols="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="text-subtitle-1"
                      >Car Details</v-card-title
                    >
                    <v-card-text>
                      <b>Regno:</b> {{ editedItem.RegNo }}<br />
                      <b>Brand:</b> {{ editedItem.Brand }}<br />
                      <b>Model:</b> {{ editedItem.Model }}<br />
                      <b>Vin:</b> {{ editedItem.Vin }}<br />
                      <b>Orginal regno:</b> *************<br />
                      <b>Pick up location:</b>
                      {{ editedItem.PickupAddress }}<br />
                      <b>Delivery location:</b>
                      {{ editedItem.DestinationAddress }}
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
          <v-btn color="blue darken-1" text @click="saveSingle">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title>
          <span class="text-h5 mt-5">Confirm vehicles delivered to store</span>
          <span class="text-subtitle-1 mt-5">
            Please confirm that these vehicles has been delivered to the
            destination as agreed.
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" lg="12">
                <span class="text-subtitle-1">
                  These vehicles has been delivered?
                </span>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <v-container class="mt-0">
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Regno</th>
                      <th class="text-left">Brand</th>
                      <th class="text-left">Model</th>
                      <th class="text-left">Vin</th>
                      <th class="text-left">Orginal regno</th>
                      <th class="text-left">Pickup location</th>
                      <th class="text-left">Delivery location</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in selected" :key="item.RegNo">
                      <td>{{ item.RegNo }}</td>
                      <td>{{ item.Brand }}</td>
                      <td>{{ item.Model }}</td>
                      <td>{{ item.Vin }}</td>
                      <td>*************</td>
                      <td>{{ item.PickupAddress }}</td>
                      <td>{{ item.DestinationAddress }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-container>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
          <v-btn color="blue darken-1" text @click="saveMultiple">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <infoSnack
      v-if="noSelection"
      :snackMessage="snackMessage"
      :snackType="snackType"
      @onSnackClose="closeSnackbar"
    />
    <editOrderSingle
      v-if="editSingleDialog"
      :editedItem="editedItem"
      page="inDelivery"
      @onEditClose="closeEditDialog"
      @onEditSave="saveNewDates"
    />
    <editOrderMulti
      v-if="editMultiDialog"
      :selectedProp="selected"
      @onEditClose="closeEditDialogMulti"
      @onEditSave="saveNewDatesMulti"
    />
    <orderHistory
      v-if="historyDialog"
      :history="history"
      @onHistoryClose="closeOrderHistory"
    />
    <confirm
      v-if="confirmVisible"
      :confirmMessage="confirmMessage"
      @onConfirmClose="closeConfirmDialog"
      @onConfirmAccept="ConfirmReturnToPreviousState"
    />
  </v-card>
</template>
<script>
import { dataActions } from "@/store/actions";
import { dataGetters } from "@/store/getters";
import { mapActions, mapGetters } from "vuex";
import { helpersMixin } from "@/mixins/mixins.js";
import infoSnack from "@/components/snackbars/info-snack.vue";
import editOrderSingle from "@/components/dialogs/edit-order-single.vue";
import editOrderMulti from "@/components/dialogs/edit-order-multi.vue";
import orderHistory from "@/components/dialogs/order-history.vue";
import confirm from "@/components/dialogs/confirm.vue";

export default {
  mixins: [helpersMixin],
  components: {
    infoSnack,
    editOrderSingle,
    editOrderMulti,
    orderHistory,
    confirm,
  },
  name: "InDelivery",
  data() {
    return {
      // service: {
      //   service: "GetInDelivery",
      // },
      maxChars: (v) => !v || v.length <= 15 || "Input too long!",
      confirmVisible: false,
      confirmMessage: "",
      historyDialog: false,
      history: {},
      editSingleDialog: false,
      editMultiDialog: false,
      expanded: [],
      single: true,
      selected: [],
      noSelection: false,
      snackMessage: "No transports selected!",
      snackType: "info",
      singleExpand: true,
      search: "",
      dialog: false,
      dialogEditDates: false,
      editedIndex: -1,
      headers: [
        { text: "Confirm as delivered", value: "actions", sortable: false },
        { text: "", value: "data-table-expand" },
        { text: "id", value: "Id" },
        // {
        //   text: "Regno",
        //   // align: "start",
        //   value: "RegNo",
        //   sortable: true,
        // },
        { text: "VIN", value: "Vin", sortable: true },
        {
          text: "Confirmed pick up",
          value: "ConfirmedPickupTime",
          sortable: true,
        },
        {
          text: "Confirmed delivery",
          value: "ConfirmedDeliveryTime",
          sortable: true,
        },
        { text: "Pickup country", value: "PickupCountry", sortable: false },
        { text: "Pickup location", value: "PickupAddress", sortable: false },
        { text: "Destination", value: "Destination", sortable: false },
        { text: "REF (edit)", value: "Ref", sortable: true },
        { text: "Edit", value: "actionsEdit", sortable: false },
      ],
      editedItem: {},
      defaultItem: {},
      editedItems: [],
      datePickup: this.dateNow(),
      dateDelivery: this.dateNow(),
      dateFormattedPickup: this.formatDate(this.dateNow()),
      dateFormattedDelivery: this.formatDate(this.dateNow()),
      dateMenu1: false,
      dateMenu2: false,
      minAllowedDatePickup: this.dateNow(),
      minAllowedDateDelivery: this.dateNow(),
      papersChecked: false,
      driverNotes: "",
    };
  },
  computed: {
    ...mapGetters({
      transportOrders: dataGetters.GET_TRANSPORT_ORDERS_IN_DELIVERY,
      transportLogs: dataGetters.GET_LOGS,
      isLoading: dataGetters.IS_LOADING,
      messageFromServer: dataGetters.GET_MESSAGE_FROM_SERVER,
      userName: dataGetters.GET_USERNAME,
      errorBasic: dataGetters.GET_ERROR_BASIC,
    }),
    noData() {
      if (this.transportOrders.length > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    transportOrders() {
      this.transportOrders.forEach((entry) => {
        let formatted = entry.ConfirmedPickupTime.includes(".");
        if (!formatted) {
          entry.ConfirmedPickupTime = this.convertDate(
            entry.ConfirmedPickupTime
          );
          entry.ConfirmedDeliveryTime = this.convertDate(
            entry.ConfirmedDeliveryTime
          );
        }
      });
    },
    datePickup() {
      this.dateFormattedPickup = this.formatDate(this.datePickup);
      this.minAllowedDateDelivery = this.datePickup;
    },
    dateDelivery() {
      this.dateFormattedDelivery = this.formatDate(this.dateDelivery);
    },
  },
  methods: {
    ...mapActions({
      // getTransportOrdersAction: dataActions.GET_TRANSPORT_ORDERS,
      getLogs: dataActions.GET_LOGS,
      updateTransportOrders: dataActions.UPDATE_TRANSPORT_ORDERS,
      updateTransportOrdersKMS: dataActions.UPDATE_TRANSPORT_ORDERS_KMS,
    }),
    saveSingle() {
      let payload = {
        service: "ConfirmedDelivery",
        serviceType: "POST",
        deliveredTime: this.dateNow(),
        orderStatus: 5,
        orderStatusText: "Delivered",
        updater: this.userName,
        rowKey: this.editedItem.Id,
      };

      let payloadKMS = {
        regNo: this.editedItem.RegNo,
        vinCode: this.editedItem.Vin,
        delivered: this.dateNow(),
      };

      // Call Transport UI backend api
      this.updateTransportOrders(payload);
      // Call KMS backend api
      this.updateTransportOrdersKMS(payloadKMS);

      // Remove from UI
      this.transportOrders.splice(this.editedIndex, 1);
      this.editedIndex = -1;
      this.dialog = false;
    },
    saveMultiple() {
      let dataArray = new Array();
      this.selected.forEach((item) => {
        dataArray.push({
          deliveredTime: this.dateNow(),
          orderStatus: 5,
          orderStatusText: "Delivered",
          updater: this.userName,
          rowKey: item.Id,
        });

        // Call KMS backend api
        let payloadKMS = {
          regNo: item.RegNo,
          vinCode: item.Vin,
          delivered: this.dateNow(),
        };
        this.updateTransportOrdersKMS(payloadKMS);
      });

      let payload = {
        service: "ConfirmedDelivery",
        serviceType: "POST",
        updater: this.userName,
        confirmDataArray: dataArray,
      };
      // Call Transport UI backend api
      // this.updateConfirmedPickupDeliveryTimes(payload);
      this.updateTransportOrders(payload);

      // Remove from UI
      for (var i = 0; i < this.selected.length; i++) {
        const index = this.transportOrders.indexOf(this.selected[i]);
        this.transportOrders.splice(index, 1);
      }
      this.editedIndex = -1;
      this.selected = [];
      this.dialog = false;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    ConfirmPickup(item) {
      this.single = true;
      this.editedIndex = this.transportOrders.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    ConfirmPickupSelected() {
      this.single = false;
      if (this.selected.length > 1) {
        this.dialog = true;
      } else {
        this.snackType = "info";
        this.noSelection = true;
      }
    },
    closeSnackbar() {
      this.noSelection = false;
    },
    closeEditDialog() {
      this.editSingleDialog = false;
    },
    closeEditDialogMulti() {
      this.editMultiDialog = false;
    },
    saveNewDates(dates) {
      let pickupTime = "";
      let deliveryTime = "";

      if (dates.dateParsedPickup) {
        pickupTime = dates.dateParsedPickup;
      } else {
        pickupTime = this.parseDate(this.editedItem.EstimatedPickupTime);
      }

      if (dates.dateParsedDelivery) {
        deliveryTime = dates.dateParsedDelivery;
      } else {
        deliveryTime = this.parseDate(this.editedItem.EstimatedDeliveryTime);
      }

      let payload = {
        service: "SaveNewDatesConfirmed",
        serviceType: "POST",
        confirmedPickupTime: dates.dateParsedPickup,
        confirmedDeliveryTime: dates.dateParsedDelivery,
        updater: this.userName,
        rowKey: this.editedItem.Id,
      };

      let payloadKMS = {
        regNo: this.editedItem.RegNo,
        vinCode: this.editedItem.Vin,
        estimatedArriveDate: deliveryTime,
        pickedUp: pickupTime,
      };

      // Call Transport UI backend api
      this.updateTransportOrders(payload);

      // Call KMS backend api
      this.updateTransportOrdersKMS(payloadKMS);

      this.editedItem.ConfirmedPickupTime = this.formatDate(pickupTime);
      this.editedItem.ConfirmedDeliveryTime = this.formatDate(deliveryTime);

      if (this.editedIndex > -1) {
        Object.assign(this.transportOrders[this.editedIndex], this.editedItem);
      } else {
        this.transportOrders.push(this.editedItem);
      }

      this.editSingleDialog = false;
    },
    saveNewDatesMulti(dates) {
      let index = 0;
      let dataArray = new Array();
      this.selected.forEach((item) => {
        let pickupTime = "";
        let deliveryTime = "";

        if (dates.dateParsedPickup) {
          pickupTime = dates.dateParsedPickup;
        } else {
          pickupTime = this.parseDate(item.EstimatedPickupTime);
        }

        if (dates.dateParsedDelivery) {
          deliveryTime = dates.dateParsedDelivery;
        } else {
          deliveryTime = this.parseDate(item.EstimatedDeliveryTime);
        }

        dataArray.push({
          confirmedPickupTime: pickupTime,
          confirmedDeliveryTime: deliveryTime,
          updater: this.userName,
          rowKey: item.Id,
        });

        this.selected[index].ConfirmedPickupTime = this.formatDate(pickupTime);
        // eslint-disable-next-line prettier/prettier
        this.selected[index].ConfirmedDeliveryTime = this.formatDate(deliveryTime);
        index++;

        // Call KMS backend api
        let payloadKMS = {
          regNo: item.RegNo,
          vinCode: item.Vin,
          estimatedArriveDate: deliveryTime,
          pickedUp: pickupTime,
        };

        this.updateTransportOrdersKMS(payloadKMS);
      });

      let payload = {
        service: "SaveNewDatesConfirmed",
        serviceType: "POST",
        confirmDataArray: dataArray,
        updater: this.userName,
      };

      // Call Transport UI backend api
      this.updateTransportOrders(payload);

      this.editedIndex = -1;
      this.selected = [];
      this.editMultiDialog = false;
    },
    editSingle(item) {
      this.editedIndex = this.transportOrders.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editSingleDialog = true;
    },
    editMultiple() {
      if (this.selected.length > 1) {
        this.editMultiDialog = true;
      } else {
        this.snackType = "info";
        this.noSelection = true;
      }
    },
    closeOrderHistory() {
      this.historyDialog = false;
    },
    async ShowHistory(item) {
      let payload = {
        service: "GetLogs",
        serviceType: "GET",
        rowKey: item.Id,
        updater: this.userName,
      };
      await this.getLogs(payload);
      this.history = {
        id: item.Id,
        regno: item.RegNo,
        historyArray: this.transportLogs,
      };
      this.historyDialog = true;
    },
    ReturnToPrevious(item) {
      this.editedItem = item;
      this.editedIndex = this.transportOrders.indexOf(item);
      this.confirmMessage =
        "Confirm you want to move this order back to PENDING CONFIRMATION state.";
      this.confirmVisible = true;
    },
    ConfirmReturnToPreviousState() {
      let payload = {
        service: "MoveOrderPreviousState",
        serviceType: "POST",
        orderStatus: 3,
        orderStatusText: "Waiting for pick up",
        updater: this.userName,
        rowKey: this.editedItem.Id,
      };

      // Call Transport UI backend api
      this.updateTransportOrders(payload);

      // Canceling to previous state has no support in KMS
      // let payloadKMS = {
      //   regNo: this.editedItem.RegNo,
      //   vinCode: this.editedItem.Vin,
      //   cancel: "inDelivery",
      // };

      // Send transport notes to KMS
      // this.updateTransportOrdersKMS(payloadKMS);

      // Remove from UI
      this.transportOrders.splice(this.editedIndex, 1);
      this.editedIndex = -1;
      this.confirmVisible = false;
    },
    closeConfirmDialog() {
      this.confirmVisible = false;
    },
    saveRef(item) {
      let payload = {
        service: "SaveCommon",
        serviceType: "POST",
        ref: item.Ref,
        updater: this.userName,
        rowKey: item.Id,
      };
      this.updateTransportOrders(payload);

      this.editedIndex = this.transportOrders.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
    SaveTransportNotes(item) {
      let payload = {
        service: "SaveCommon",
        serviceType: "POST",
        transportNotes: item.TransportNotes,
        updater: this.userName,
        rowKey: item.Id,
      };
      // Call Transport UI backend api
      this.updateTransportOrders(payload);

      // KMS does not support updating transport notes
      // let payloadKMS = {
      //   regNo: item.RegNo,
      //   vinCode: item.Vin,
      //   transportNotes: item.TransportNotes,
      // };

      // Send transport notes to KMS
      // this.updateTransportOrdersKMS(payloadKMS);
    },
  },
};
</script>
<style scoped>
.oneLine {
  text-align: left;
}
</style>
